import LogHistoryName from "./LogHistoryName";
import LogHistoryLink from "./LogHistoryLink";

import LogName from "../../../../timber/components/log/LogDetail/LogName";
import LogLink from "../../../../timber/components/log/LogDetail/LogLink";

import TimberStorageName from "../../../../timber/components/timberStorage/TimberStorageDetail/TimberStorageName";
import TimberStorageLink from "../../../../timber/components/timberStorage/TimberStorageDetail/TimberStorageLink";

import LocationName from "../../../../location/components/location/LocationDetail/LocationName";
import LocationLink from "../../../../location/components/location/LocationDetail/LocationLink";

import CuttingName from "../../../../timber/components/cutting/CuttingDetail/CuttingName";
import CuttingLink from "../../../../timber/components/cutting/CuttingDetail/CuttingLink";

import ShipmentName from "../../../../timber/components/shipment/ShipmentDetail/ShipmentName";
import ShipmentLink from "../../../../timber/components/shipment/ShipmentDetail/ShipmentLink";

import TimberTypeName from "../../../../timber/components/timberType/TimberTypeDetail/TimberTypeName";
import TimberTypeLink from "../../../../timber/components/timberType/TimberTypeDetail/TimberTypeLink";

import TimberClassName from "../../../../timber/components/timberClass/TimberClassDetail/TimberClassName";
import TimberClassLink from "../../../../timber/components/timberClass/TimberClassDetail/TimberClassLink";

import ThicknessClassName from "../../../../timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassName";
import ThicknessClassLink from "../../../../timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassLink";
import { toStringDisplay as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { toStringDisplay as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { toStringDisplay as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { toStringDisplay as toStringUserType } from "../../../types/models/UserType.d";
import { toStringDisplay as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import {NavLink, useParams} from "react-router";

import Grid from '@mui/material/Grid';
import { Refresh, Clear, CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const LogHistoryDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" spacing={1} sx={{ justifyContent: "left" }}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="LogHistory-detail-title"
                    >
                        { label || t`Log History` }: <LogHistoryName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" spacing={1} sx={{ justifyContent: "right" }}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="LogHistory-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="LogHistory-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    
                    <Grid size={ {xs: 4} } data-testid="logId-label" sx={{ textAlign: "left" }}><Trans>Log</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="logId-value" sx={{ textAlign: "left" }}>{ data.logId ? (<LogLink id={ data.logId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="action-label" sx={{ textAlign: "left" }}><Trans>Action</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="action-value" sx={{ textAlign: "left" }}>{ data.action || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="contextHistory-label" sx={{ textAlign: "left" }}><Trans>Context History</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="contextHistory-value" sx={{ textAlign: "left" }}>{ data.contextHistory || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="updatedAt-label" sx={{ textAlign: "left" }}><Trans>Updated At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="updatedAt-value" sx={{ textAlign: "left" }}>{displayDateTime(data.updatedAt) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="internalKey-label" sx={{ textAlign: "left" }}><Trans>IK</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="internalKey-value" sx={{ textAlign: "left" }}>{ data.internalKey || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="timberKey-label" sx={{ textAlign: "left" }}><Trans>Timber Key</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="timberKey-value" sx={{ textAlign: "left" }}>{ data.timberKey || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="volume-label" sx={{ textAlign: "left" }}><Trans>Volume (m&#xB3;)</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="volume-value" sx={{ textAlign: "left" }}>{fixedFormat(data.volume) || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="storageId-label" sx={{ textAlign: "left" }}><Trans>Timber Storage</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="storageId-value" sx={{ textAlign: "left" }}>{ data.storageId ? (<TimberStorageLink id={ data.storageId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="locationId-label" sx={{ textAlign: "left" }}><Trans>Location</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="locationId-value" sx={{ textAlign: "left" }}>{ data.locationId ? (<LocationLink id={ data.locationId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="cuttingId-label" sx={{ textAlign: "left" }}><Trans>Cutting</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="cuttingId-value" sx={{ textAlign: "left" }}>{ data.cuttingId ? (<CuttingLink id={ data.cuttingId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="shipmentId-label" sx={{ textAlign: "left" }}><Trans>Shipment</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="shipmentId-value" sx={{ textAlign: "left" }}>{ data.shipmentId ? (<ShipmentLink id={ data.shipmentId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="state-label" sx={{ textAlign: "left" }}><Trans>State</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="state-value" sx={{ textAlign: "left" }}>{ toStringShipmentState(data.state) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="length-label" sx={{ textAlign: "left" }}><Trans>Length (cm)</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="length-value" sx={{ textAlign: "left" }}>{(data.length) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="diameter-label" sx={{ textAlign: "left" }}><Trans>Diameter (cm)</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="diameter-value" sx={{ textAlign: "left" }}>{(data.diameter) || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="timberTypeId-label" sx={{ textAlign: "left" }}><Trans>Timber Type</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="timberTypeId-value" sx={{ textAlign: "left" }}>{ data.timberTypeId ? (<TimberTypeLink id={ data.timberTypeId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="classId-label" sx={{ textAlign: "left" }}><Trans>Timber Class</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="classId-value" sx={{ textAlign: "left" }}>{ data.classId ? (<TimberClassLink id={ data.classId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="thicknessClassId-label" sx={{ textAlign: "left" }}><Trans>Thickness Class</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="thicknessClassId-value" sx={{ textAlign: "left" }}>{ data.thicknessClassId ? (<ThicknessClassLink id={ data.thicknessClassId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="linked-label" sx={{ textAlign: "left" }}><Trans>Linked</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="linked-value" sx={{ textAlign: "left" }}>{ data.linked ? (<CheckBoxOutlinedIcon/>) : (<CheckBoxOutlineBlankOutlinedIcon/>) }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="barkThickness-label" sx={{ textAlign: "left" }}><Trans>Bark Thickness</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="barkThickness-value" sx={{ textAlign: "left" }}>{(data.barkThickness) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="commited-label" sx={{ textAlign: "left" }}><Trans>Commited</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="commited-value" sx={{ textAlign: "left" }}>{ data.commited ? (<CheckBoxOutlinedIcon/>) : (<CheckBoxOutlineBlankOutlinedIcon/>) }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="localCreatedAt-label" sx={{ textAlign: "left" }}><Trans>Local Created At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="localCreatedAt-value" sx={{ textAlign: "left" }}>{displayDateTime(data.localCreatedAt) || '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default LogHistoryDetail;
